import { get } from 'lodash'

export const getSourceUrl = (video = {}) => {
  let playUrl = ''
  const cdnUrls = get(video, 'cdnPlayInfo.playUrls', []);
  const barePlayUrl = video.barePlayUrl || '';

  if (cdnUrls.length > 0) {
    playUrl = cdnUrls[0];
  } else if (barePlayUrl) {
    playUrl = barePlayUrl;
  }
  return playUrl
}